import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {getReservationItems as getReservationItemsApi} from '../../../services/groups'

export async function getReservationStatusStates(dispatch, params) {
  try {
    dispatch({type: PENDING})
    let response = await getReservationItemsApi(params)
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Get Reservation Configuration Failed`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
